import { Fade, Menu, MenuItem } from '@mui/material';
import { CaretDown, CaretUp, Check } from '@phosphor-icons/react';
import { Avatar, Button } from 'components';
import { useUser } from 'features/auth';
import { useTableContext } from 'features/misc/table/providers/TableProvider';
import React from 'react';
import { useTheme } from '@emotion/react';

export const Dropdown = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const { table } = useTableContext();
  const { data } = useUser();
  if (!table.options?.meta?.viewOptions?.options.length) {
    return null;
  }
  let value = table.options.meta.viewOptions.initialValue
    ? table.options.meta.viewOptions.options.find(
        o => o.id === table.options.meta?.viewOptions?.initialValue
      )?.id
    : undefined;
  if (table.options.meta.tableState[table.options.meta.viewOptions.tableStateField]) {
    value = table.options.meta.tableState[table.options.meta.viewOptions.tableStateField];
  }

  return (
    <>
      <Button
        sx={{
          color: theme.palette.text.secondary,
          fontSize: '16px',
          border: `0.5px solid ${theme.palette.border.primarySubtle}`,
          borderRadius: '8px',
          backgroundColor: theme.palette.bg.primary,
        }}
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={
          value === '1' || value === '4' ? (
            <Avatar size="xsm" letters={data?.loginContext?.name} />
          ) : undefined
        }
        endIcon={
          open ? (
            <CaretUp size={20} color={theme.palette.fg.primary} />
          ) : (
            <CaretDown size={20} color={theme.palette.fg.primary} />
          )
        }
      >
        {table.options.meta?.viewOptions?.options?.find(item => item?.value === value)?.label}
      </Button>
      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        slotProps={{ paper: { sx: { minWidth: '215px', marginTop: '8px' } } }}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {table.options.meta?.viewOptions?.options?.map(item => (
          <MenuItem
            sx={{
              fontWeight: item?.value === value ? 600 : 400,
              gap: '8px',
              padding: '6px 16px',
              minHeight: '32px',
              marginBlock: '4px',
              fontSize: '0.875rem',
              background: item?.value === value ? theme.palette.bg.secondary : undefined,
              color: theme.palette.text.secondary,
            }}
            key={item?.id}
            onClick={() => {
              if (
                table.options.meta?.onTableStateChange &&
                table.options.meta.viewOptions?.tableStateField
              ) {
                if (item) {
                  table.options.meta.onTableStateChange({
                    [table.options.meta.viewOptions.tableStateField]: item?.value,
                    cursor: null,
                    page: null,
                  });
                }
              }
              handleClose();
            }}
          >
            <span>{item?.label}</span>{' '}
            {item.value === value && <Check size={16} color={theme.palette.primary.main} />}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Dropdown;
